import React from "react";

const CuisineCard = ({ name, image, onClick }) => {
  return (
    <div className="cuisine-card" onClick={onClick}>
      <div className="cuisine-title text-med-emphasis">{name}</div>
      <div className="cuisine-img">
        <img src={image} alt={name} />
      </div>
    </div>
  );
};

export default CuisineCard;
